import { useState } from "react";
import { X } from "lucide-react";

const MAX_TAGS = 20;

const splitTags = (text) => text.split(",").map((t) => t.trim()).filter(Boolean);

export const KeywordTagInput = ({ id, value, onChange, placeholder, testId }) => {
  const [draft, setDraft] = useState("");

  const addTags = (text) => {
    const existing = new Set(value.map((v) => v.toLowerCase()));
    const next = [...value];
    splitTags(text).forEach((t) => {
      if (next.length < MAX_TAGS && !existing.has(t.toLowerCase())) {
        next.push(t.slice(0, 80));
        existing.add(t.toLowerCase());
      }
    });
    onChange(next);
    setDraft("");
  };

  const removeTag = (idx) => onChange(value.filter((_, i) => i !== idx));

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && draft.trim()) {
      e.preventDefault();
      addTags(draft);
    } else if (e.key === "Backspace" && !draft && value.length) {
      removeTag(value.length - 1);
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    if (v.includes(",")) addTags(v);
    else setDraft(v);
  };

  return (
    <div
      className="flex flex-wrap items-center gap-1.5 min-h-10 rounded-xl border border-input bg-background px-2.5 py-1.5 focus-within:ring-2 focus-within:ring-ring"
      data-testid={testId}
    >
      {value.map((tag, i) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 rounded-full bg-primary/10 text-primary text-xs font-medium pl-2.5 pr-1 py-1"
          data-testid={`${testId}-tag-${i}`}
        >
          {tag}
          <button
            type="button"
            onClick={() => removeTag(i)}
            className="rounded-full p-0.5 hover:bg-primary/20"
            aria-label={`Remove ${tag}`}
            data-testid={`${testId}-remove-${i}`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        id={id}
        value={draft}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={() => draft.trim() && addTags(draft)}
        placeholder={value.length ? "" : placeholder}
        disabled={value.length >= MAX_TAGS}
        className="flex-1 min-w-[160px] bg-transparent text-sm outline-none py-1 placeholder:text-muted-foreground"
        data-testid={`${testId}-field`}
      />
    </div>
  );
};
